import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { ToastContainer, toast } from "react-toastify";
import { loginUser } from "../authServices";
import { Link, useNavigate } from "react-router-dom";
import { Button, Form } from "react-bootstrap";
import { FaFacebook } from "react-icons/fa";
import { BsGithub, BsGoogle } from "react-icons/bs";
import login from "../../../Assets/login.svg";
import logo from "../../../Assets/logo.png";
import { db } from "../../../Firebase";
import { doc, onSnapshot, collection, query } from "firebase/firestore";
import "./Connexion.css";
import { DASHBOARD_ADMIN_NAVIGATION, DASHBOARD_PROF_NAVIGATION, DASHBOARD_ETUDIANT_NAVIGATION, PASSWORD_OUBLIER_NAVIGATION } from "../../../Routes/NAVIGATION_PATH";

export default function Inscription() {
  const [userLoginData, setUserLoginData] = useState({});
  const [user_id, setUserId] = useState("");
  const [user_type, setUserType] = useState("");
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();


  const onSubmit = (data) => {
    const { email, password } = data;
    loginUser(email, password)
      .then((userCredential) => {
        const user_id = userCredential.user.uid;

        onSnapshot(doc(db, "users", user_id), (doc) => {
          const user = doc.data().user_type;
          //setUserType(user)
          handleRedirect(user);
        });

        // toast.success("Connexion reussie !");
      })
      .catch((error) => {
        toast.error("Utilisateur introuvable ou mot de passe incorect!");
        const errorCode = error.code;
        console.log(errorCode);
      });
    reset();
  };

  const handleRedirect = (type) => {
    if (type === "admin") {
      navigate(DASHBOARD_ADMIN_NAVIGATION);
    } else if (type === "prof") {
      navigate(DASHBOARD_PROF_NAVIGATION);
    } else if (type === "etudiant") {
      navigate(DASHBOARD_ETUDIANT_NAVIGATION);
    }
  };





 return (
    <div className="container-fluid p-0 " id="login">
      <div className="row d-flex justify-content-center align-items-center w-100 min-vh-100">
        <div className="col-lg-6  p-0 pt-0 d-none d-lg-block">
          <div className="container-bg style-border  d-flex justify-content-center align-items-center w-100 min-vh-100 "><img src={login} className="img-fluid imLogin" /></div>
        </div>

        <div className="col-lg-6  p-4  min-vh-100">
          <div className="container-img w-100 d-flex justify-content-center text-center">
            <img src={logo} className='img-fluid logLogin ' />
          </div>
          <div className="tiitle-h2">
            <h2>CONNEXION</h2>
          </div>
          <Form onSubmit={handleSubmit(onSubmit)} className='mx-auto'>
          
            <Form.Group className="" controlId="formBasicEmail">
              <Form.Label>Adresse email ou nom utilisateur</Form.Label>
              <Form.Control
                {...register("email")}
                type="email"
                placeholder="Enter email"
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formBasicPassword">
              <Form.Label>Mot de pass</Form.Label>
              <Form.Control
                {...register("password")}
                type="password"
                placeholder="Password"
              />
            </Form.Group>
            <div className="mb-3 form-check">
              <input
                type="checkbox"
                className="form-check-input"
                id="exampleCheck1"
              />
              <div className="d-flex justify-content-between">
                <label className="form-check-label" for="exampleCheck1">
                  {" "}
                  Souvenez-vous de moi{" "}
                </label>
                <Link to = {PASSWORD_OUBLIER_NAVIGATION} >
                  <span> Vous avez oublié votre mot de passe ?</span>
                </Link>
              </div>
            </div>

            <button type="submit" className="block-btn btn btn-lg">
              connexion
            </button>
            <ToastContainer />
          </Form>
          <div className="d-flex justify-content-center align-items-center  p-4 ">
            <span className="p-1">
              <FaFacebook />
            </span>
            <span className="p-1">
              <BsGithub />
            </span>
            <span className="p-1">
              <BsGoogle />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
